import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import {
  VALIDATE_FORM_FIELD,
  VALIDATE_FORM_FIELD_SUCCESS,
  VALIDATE_FORM_FIELD_ERROR
} from "../lib/formsReducer";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { pagesList, category } from "../app/schema";
import { Map, fromJS } from "immutable";

export const GET_PAGES_LISTS = "GET_PAGES_LISTS";
export const GET_PAGES_LIST = "GET_PAGES_LIST";
export const GET_PAGES_LIST_BY_SLUG = "GET_PAGES_LIST_BY_SLUG";
export const GET_PAGES_LIST_BY_SLUG_FILMS = "GET_PAGES_LIST_BY_SLUG_FILMS";
export const POST_PAGES_LISTS = "POST_PAGES_LISTS";
export const PATCH_PAGES_LIST = "PATCH_PAGES_LIST";
export const DELETE_PAGES_LIST = "DELETE_PAGES_LIST";
export const GET_PAGES_LIST_CATEGORIES = "GET_PAGES_LIST_CATEGORIES";
export const POST_PAGES_LIST_CATEGORIES = "POST_PAGES_LIST_CATEGORIES";

export const SET_IS_ADD_PAGES_LIST_MODAL_VISIBLE =
  "SET_IS_ADD_PAGES_LIST_MODAL_VISIBLE";
export const SET_IS_REMOVE_PAGES_LIST_MODAL_VISIBLE =
  "SET_IS_REMOVE_PAGES_LIST_MODAL_VISIBLE";
export const SET_IS_EDIT_PAGES_LIST_MODAL_VISIBLE =
  "SET_IS_EDIT_PAGES_LIST_MODAL_VISIBLE";
export const SET_IS_ADD_PAGES_LIST_CATEGORY_MODAL_VISIBLE =
  "SET_IS_ADD_PAGES_LIST_CATEGORY_MODAL_VISIBLE";

export const SET_PAGE_LIST_PAGINATION_PAGE = "SET_PAGE_LIST_PAGINATION_PAGE";
export const RESET_PAGE_LIST_PAGINATION = "RESET_PAGE_LIST_PAGINATION";

// Validation
const validateForm = {
  createPagesList: (validate, fields, oneField) =>
    validate(fields, oneField) // .prop('name', 'Nazwa').required()
      .getErrors().promise,
  createPagesListCategory: (validate, fields, oneField) =>
    validate(fields, oneField) // .prop('name', 'Nazwa').required()
      .getErrors().promise
};

// Requests

const getPagesListsGet = (fetch, apiHost, accessToken, meta, sort) =>
  fetch(
    `${apiHost}/v1/pages-lists?limit=${meta.limit}&offset=${meta.currentPage *
      meta.limit}&sortField=${sort.field}&sortDir=${
      sort.isDirectionAscending ? "asc" : "desc"
    }`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      },
      method: "GET"
    }
  ).then(response => {
    return validateResponse(response, {});
  });

const getPagesListGet = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/pages-lists/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const getPagesListBySlugGet = (
  fetch,
  apiHost,
  accessToken,
  slug,
  meta,
  search,
  sort
) =>
  fetch(
    `${apiHost}/v1/pages-list/${slug}?limit=${
      meta.limit
    }&offset=${meta.currentPage * meta.limit}${
      sort
        ? "&sortPageField=" +
          sort.field +
          "&sortPageDir=" +
          (sort.isDirectionAscending ? "ASC" : "DESC")
        : ""
    }${
      search
        ? "&fieldPlaceholder=title&fieldValue=" +
          search.name +
          "&fieldOperation=AND&fieldOperator=LIKE"
        : ""
    }`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      },
      method: "GET"
    }
  ).then(response => {
    return validateResponse(response, {});
  });

const postPagesLists = (fetch, apiHost, accessToken, data) =>
  fetch(`${apiHost}/v1/pages-lists`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "POST"
  }).then(response => {
    return validateResponse(response, {});
  });

const patchPagesList = (fetch, apiHost, accessToken, uid, data) =>
  fetch(`${apiHost}/v1/pages-lists/${uid}`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {});
  });

const deletePagesList = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/pages-lists/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "DELETE"
  }).then(response => {
    return validateResponse(response, {
      validation_error: {
        msg:
          "Nie można usunąć danych tłumaczenia strony, ponieważ są one używane przez inne zasoby.",
        field: "all"
      }
    });
  });

const getPagesListCategoriesGet = (fetch, apiHost, accessToken, slug) =>
  fetch(`${apiHost}/v1/pages-lists/${slug}/categories?limit=1000`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const postPagesListsCategory = (fetch, apiHost, accessToken, data, uid) =>
  fetch(`${apiHost}/v1/pages-lists/${uid}/categories`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "POST"
  }).then(response => {
    return validateResponse(response, {
      duplicate: {
        field: "all",
        msg: "Slug nie może się powtarzać"
      }
    });
  });

// Actions

export function getPagesLists(meta, sort) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_PAGES_LISTS],
    payload: {
      promise: getPagesListsGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        meta,
        sort
      )
        .then(data => {
          return normalize(data, {
            pageLists: arrayOf(pagesList)
          });
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function getPagesList(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_PAGES_LIST],
    payload: {
      promise: getPagesListGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      )
        .then(data => {
          return normalize(data, pagesList);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        }),
      data: {
        uid
      }
    }
  });
}

export function getPagesListBySlug(slug, meta, search, sort) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_PAGES_LIST_BY_SLUG],
    payload: {
      promise: getPagesListBySlugGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        slug,
        meta,
        search,
        sort
      )
        .then(data => {
          let pages = new Map();
          data.pages.forEach(function(item) {
            pages = pages.set(item.uid, fromJS(item));
          });
          data.pages = pages;
          return normalize(data, pagesList);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        }),
      data: {
        slug
      }
    }
  });
}

export function getPagesListBySlugFilms(slug, meta, search, sort) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_PAGES_LIST_BY_SLUG_FILMS],
    payload: {
      promise: getPagesListBySlugGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        slug,
        meta,
        search,
        sort
      )
        .then(data => {
          let pages = new Map();
          data.pages.forEach(function(item) {
            pages = pages.set(item.uid, fromJS(item));
          });
          data.pages = pages;
          return normalize(data, pagesList);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        }),
      data: {
        slug
      }
    }
  });
}

export function createPagesList(data) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [POST_PAGES_LISTS],
    payload: {
      promise: validateForm["createPagesList"](validate, data)
        .then(() =>
          postPagesLists(
            fetch,
            config().apiHost,
            users().viewer.accessToken,
            data
          )
        )
        .then(data => {
          return normalize(data, pagesList);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function updatePagesList(data, uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [PATCH_PAGES_LIST],
    payload: {
      promise: patchPagesList(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        data
      )
        .then(data => {
          return normalize(data, pagesList);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function removePagesList(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [DELETE_PAGES_LIST],
    payload: {
      promise: deletePagesList(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      }),
      data: {
        uid
      }
    }
  });
}

export function getPagesListCategories(slug) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_PAGES_LIST_CATEGORIES],
    payload: {
      promise: getPagesListCategoriesGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        slug
      )
        .then(data => {
          return normalize(data, {
            categories: arrayOf(category)
          });
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    },
    meta: {
      slug
    }
  });
}

export function createPagesListCategory(data, uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [POST_PAGES_LIST_CATEGORIES],
    payload: {
      promise: validateForm["createPagesListCategory"](validate, data)
        .then(() =>
          postPagesListsCategory(
            fetch,
            config().apiHost,
            users().viewer.accessToken,
            data,
            uid
          )
        )
        .then(data => {
          return normalize(data, category);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function setIsAddPagesListModalVisible(value) {
  return {
    type: SET_IS_ADD_PAGES_LIST_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}

export function setIsRemovePagesListModalVisible(value) {
  return {
    type: SET_IS_REMOVE_PAGES_LIST_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}

export function setIsEditPagesListModalVisible(value) {
  return {
    type: SET_IS_EDIT_PAGES_LIST_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}

export function setIsAddPagesListCategoryModalVisble(value) {
  return {
    type: SET_IS_ADD_PAGES_LIST_CATEGORY_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}

export function setPageListPaginationPage(page) {
  return {
    type: SET_PAGE_LIST_PAGINATION_PAGE,
    payload: {
      page
    }
  };
}

export function resetPageListPagination() {
  return {
    type: RESET_PAGE_LIST_PAGINATION
  };
}

// Standard functions
export function validateFormFieldPagesLists(form, name, value) {
  const feature = "pagesLists";
  let fields = {};
  fields[name] = value;
  return ({ fetch, validate, config, users }) => ({
    type: [`${VALIDATE_FORM_FIELD}_${feature.toUpperCase()}`],
    payload: {
      promise: validateForm[form](validate, fields, true).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}



// WEBPACK FOOTER //
// ./src/common/pagesLists/actions.js